var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticStyle:{"position":"fixed","top":"0","left":"0","right":"0","border-radius":"0","z-index":"2000"},attrs:{"value":100,"max":100,"animated":"","height":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }